function fontStyles(theme) {
  return () => ({ fontFamily: theme.fontFamily || "sans-serif" });
}

export { fontStyles };
//# sourceMappingURL=font-styles.js.map
